var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "All-Inspections",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-Inspections-All-Sites",
    transform: "translate(-1229.000000, -954.000000)",
    fill: "#616674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-10",
    transform: "translate(207.000000, 949.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(973.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-/-Symbol-Small-/-Base",
    transform: "translate(44.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.714286, 5.714286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-View-eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-report-e9fc",
    transform: "translate(1.142857, 4.571429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14285714,3.65714286 C7.76573153,3.65714286 6.64935065,4.74871528 6.64935065,6.0952381 C6.64935065,7.44176091 7.76573153,8.53333333 9.14285714,8.53333333 C10.5199828,8.53333333 11.6363636,7.44176091 11.6363636,6.0952381 C11.6363636,4.74871528 10.5199828,3.65714286 9.14285714,3.65714286 M9.14285714,10.1587302 C6.84764779,10.1587302 4.98701299,8.33944279 4.98701299,6.0952381 C4.98701299,3.8510334 6.84764779,2.03174603 9.14285714,2.03174603 C11.4380665,2.03174603 13.2987013,3.8510334 13.2987013,6.0952381 C13.2987013,8.33944279 11.4380665,10.1587302 9.14285714,10.1587302 M9.14285714,0 C4.98701299,0 1.43792208,2.52749206 0,6.0952381 C1.43792208,9.66298413 4.98701299,12.1904762 9.14285714,12.1904762 C13.2987013,12.1904762 16.8477922,9.66298413 18.2857143,6.0952381 C16.8477922,2.52749206 13.2987013,0 9.14285714,0 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEye);
export default __webpack_public_path__ + "static/media/view-eye.9b6793c12315e6205a3a1fea310a0340.svg";
export { ForwardRef as ReactComponent };